import Vue from "vue";
import Router from "vue-router";
import { getToken } from '@/utils/token'  // 添加 token 工具函数导入
// const _import = require("./_import_" + process.env.NODE_ENV);
// const _import = file => () => import('@/views/' + file + '.vue');

// console.log("_import", _import);
import Full from "@/containers/Full";
import Full2 from "@/containers/Full2";

import Buttons from "@/views/components/Buttons";

// Views - Pages
import Page404 from "@/views/errorPages/Page404";
import Page500 from "@/views/errorPages/Page500";

/* login */
// const Login = require("@/views/login/index");
import Login from '@/views/login/index.vue';  // 改为同步加载

Vue.use(Router);

export const constantRouterMap = [
  { path: "/login", component: Login, hidden: true },
  {
    path: '/redirect',
    component: Full,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: "/pages",
    redirect: "/pages/p404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
      // Full,
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: require("@/views/errorPages/Page404").default,
      },
      {
        path: "500",
        name: "Page500",
        component: require("@/views/errorPages/Page404").default,
      },
    ],
  },
];

export const asyncRouterMap = [
  {
    path: '/admin',
    component: Full,
    name: '管理员',
    redirect: '/admin/home',
    meta: { role: ['admin'] },
    children: [
      {
        path: 'home',
        name: '首页',
        icon: 'merge',
        component: require('@/views/JsonTree.vue').default,
      },
      {
        path: '/mgc',
        name: '魔鬼城管理',
        icon: 'bookmark',
        component: { render: c => c('router-view') },
        children: [
          {
            path: 'mgcmanage',
            name: '魔鬼城列表',
            icon: 'social-youtube',
            component: require('@/views/mgc/mgcmanage').default,
          }
        ]
      },
      {
        path: "/tuibi",
        name: "推币机管理",
        redirect: "/tuibi/coinmanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "coinmanage",
            name: "推币机列表",
            icon: "social-youtube",
            component: require("@/views/tuibi/coinmanage").default,
            hidden: false,
          },
        ],
      }, {
        path: "/wawa",
        name: "娃娃机管理",
        redirect: "/wawa/wawamanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "wawamanage",
            name: "娃娃机列表",
            icon: "social-youtube",
            component: require("@/views/wawa/wawamanage").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/user",
        name: "用户管理",
        redirect: "/user/usermanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "usermanage",
            name: "用户列表",
            icon: "social-youtube",
            component: require("@/views/user/usermanage").default,
            hidden: false,
          },
          {
            path: "rechargecheck",
            name: "充值审核",
            icon: "cash",
            component: require("@/views/user/rechargecheck").default,
            hidden: false,
          },
          {
            path: "rechangRank",
            name: "充值排行",
            icon: "cash",
            component: require("@/views/user/rechangRank").default,
            hidden: false,
          },
          {
            path: "consumeRank",
            name: "消费排行",
            icon: "cash",
            component: require("@/views/user/consumeRank").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/spk",
        name: "商品库管理",
        redirect: "/spk/spklist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "spklist",
            name: "商品库列表",
            icon: "social-youtube",
            component: require("@/views/spk/spklist").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/shopmanage",
        name: "商城管理",
        redirect: "/shopmanage/shoplist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "shoplist",
            name: "商城列表",
            icon: "social-youtube",
            component: require("@/views/shopmanage/shoplist").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/fahuo",
        name: "发货管理",
        redirect: "/fahuo/fahuolist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "fahuolist",
            name: "待发货列表",
            icon: "social-youtube",
            component: require("@/views/fahuo/fahuolist").default,
            hidden: false,
          },
          {
            path: "yifahuolist",
            name: "已发货列表",
            icon: "social-youtube",
            component: require("@/views/fahuo/yifahuolist").default,
            hidden: false,
          },
        ],
      }, {
        path: "/finance",
        name: "财务管理",
        redirect: "/finance/wawalist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "wawalist",
            name: "娃娃机账",
            icon: "social-youtube",
            component: require("@/views/finance/wawalist").default,
            hidden: false,
          },
          {
            path: "coinlist",
            name: "推币机账",
            icon: "social-youtube",
            component: require("@/views/finance/coinlist").default,
            hidden: false,
          }, {
            path: "mgclist",
            name: "魔鬼城账",
            icon: "social-youtube",
            component: require("@/views/finance/mgclist").default,
            hidden: false,
          }, {
            path: "rechangelist",
            name: "充值账",
            icon: "social-youtube",
            component: require("@/views/finance/rechangelist").default,
            hidden: false,
          },
        ],
      }, {
        path: "/daycensus",
        name: "每日统计",
        redirect: "/daycensus/userlist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "userlist",
            name: "用户统计",
            icon: "android-contact",
            component: require("@/views/daycensus/userlist").default,
            hidden: false,
          }, {
            path: "rechangelist",
            name: "充值统计",
            icon: "social-usd-outline",
            component: require("@/views/daycensus/rechangelist").default,
            hidden: false,
          }, {
            path: "coinlist",
            name: "金币统计",
            icon: "help-buoy",
            component: require("@/views/daycensus/coinlist").default,
            hidden: false,
          }, {
            path: "integrlist",
            name: "能量统计",
            icon: "ios-flower",
            component: require("@/views/daycensus/integrlist").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/yymanage",
        name: "运营管理",
        redirect: "/yymanage/versionlist",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "personlist",
            name: "虚拟人物",
            icon: "social-youtube",
            component: require("@/views/yymanage/personlist").default,
            hidden: false,
          }, {
            path: "versionlist",
            name: "版本列表",
            icon: "social-youtube",
            component: require("@/views/yymanage/versionlist").default,
            hidden: false,
          }, {
            path: "bannerlist",
            name: "banner列表",
            icon: "social-youtube",
            component: require("@/views/yymanage/bannerlist").default,
            hidden: false,
          }, {
            path: "zhubolist",
            name: "主播列表",
            icon: "social-youtube",
            component: require("@/views/yymanage/zhubolist").default,
            hidden: false,
          }
        ],
      },{
        path: '/machinewring',
        name: '机器报警',
        icon: 'bookmark',
        component: { render: c => c('router-view') },
        children: [
          {
            path: 'machinealarm',
            name: '机器报警',
            icon: 'social-youtube',
            component: require('@/views/wring/machinewring').default,
          },
          {
            path: 'armonile',
            name: 'arm在线情况',
            icon: 'social-youtube',
            component: require('@/views/wring/armonile').default,
          }
        ]
      },
    ],
  },
  {
    path: '/jixiu',
    component: Full,
    name: '技修',
    redirect: '/jixiu/home',
    meta: { role: ['jixiu'] },
    children: [
      {
        path: 'home',
        name: '首页',
        icon: 'merge',
        component: require('@/views/JsonTree.vue').default,
      },
      {
        path: "/mgc",
        name: "魔鬼城管理",
        redirect: "/mgc/mgcmanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "mgcmanage",
            name: "魔鬼城列表",
            icon: "social-youtube",
            component: require("@/views/mgc/mgcmanage").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/tuibi",
        name: "推币机管理",
        redirect: "/tuibi/coinmanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "coinmanage",
            name: "推币机列表",
            icon: "social-youtube",
            component: require("@/views/tuibi/coinmanage").default,
            hidden: false,
          },
        ],
      }, {
        path: "/wawa",
        name: "娃娃机管理",
        redirect: "/wawa/wawamanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "wawamanage",
            name: "娃娃机列表",
            icon: "social-youtube",
            component: require("@/views/wawa/wawamanage").default,
            hidden: false,
          },
        ],
      },
      {
        path: "/user",
        name: "用户管理",
        redirect: "/user/usermanage",
        icon: "bookmark",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "usermanage",
            name: "用户列表",
            icon: "social-youtube",
            component: require("@/views/user/usermanage").default,
            hidden: false,
          },
          {
            path: "rechargecheck",
            name: "充值审核",
            icon: "cash",
            component: require("@/views/user/rechargecheck").default,
            hidden: false,
          },
        ],
      }
      ,{
        path: '/machinewring',
        name: '机器报警',
        icon: 'bookmark',
        component: { render: c => c('router-view') },
        children: [
          {
            path: 'machinealarm',
            name: '机器报警',
            icon: 'social-youtube',
            component: require('@/views/wring/machinewring').default,
          },
          {
            path: 'armonile',
            name: 'arm在线情况',
            icon: 'social-youtube',
            component: require('@/views/wring/armonile').default,
          }
        ]
      },
    ],
  },
  { path: "*", redirect: "/pages/404", hidden: true },
];

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

// 添加全局路由守卫
router.beforeEach((to, from, next) => {
  const hasToken = getToken()
  
  if (hasToken) {
    if (to.path === '/login') {
      // 如果已登录，获取用户信息并重定向
      const userInfo = JSON.parse(localStorage.getItem('user'))
      const defaultPath = userInfo && userInfo.menus ? '/' + userInfo.menus : '/admin'
      next({ path: defaultPath })
    } else if (to.path === '/') {
      // 根路径时，根据用户身份重定向
      const userInfo = JSON.parse(localStorage.getItem('user'))
      const defaultPath = userInfo && userInfo.menus ? '/' + userInfo.menus : '/admin'
      next({ path: defaultPath })
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      // 没有token，重定向到登录页
      next(`/login?redirect=${to.path}`)
    }
  }
})

export default router;
